import {
  DTOCreateForgeProjectContext,
  DTOForgeProjectContextCreateResponse,
  DTOForgeProjectContextListResponse,
  DTOForgeProjectContextRemoveResponse,
  DTOUpdateForgeProjectContext,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeProjectContextsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/project-contexts`,
      DTOForgeProjectContextListResponse,
      {
        method: "GET",
      }
    );
  }

  create(workspaceId: string, body: DTOCreateForgeProjectContext) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/project-contexts`,
      DTOForgeProjectContextCreateResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(workspaceId: string, contextId: string, body: DTOUpdateForgeProjectContext) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/project-contexts/${contextId}`,
      DTOForgeProjectContextCreateResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, contextId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/project-contexts/${contextId}`,
      DTOForgeProjectContextRemoveResponse,
      {
        method: "DELETE",
      }
    );
  }
}
